module.exports = __webpack_public_path__ + "img/fondesk-logo-full-vertical.57dbb3c.svg";